import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgCheckedBaggage = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <defs>
        <linearGradient
          id="checkedBaggage_svg__d"
          x1={21}
          x2={21}
          y1={27.504}
          y2={28.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="checkedBaggage_svg__e"
          x1={10.999}
          x2={10.999}
          y1={27.504}
          y2={28.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="checkedBaggage_svg__f"
          x1={10.879}
          x2={17.129}
          y1={4.579}
          y2={4.579}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DCA6FF" stopOpacity={0.9} />
          <stop offset={1} stopColor="#DAA6FF" stopOpacity={0.9} />
        </linearGradient>
        <linearGradient
          id="checkedBaggage_svg__h"
          x1={15.055}
          x2={20.961}
          y1={12.248}
          y2={12.248}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.102} stopColor="#fff" />
          <stop offset={0.115} stopColor="#E3E3E3" />
          <stop offset={0.204} stopColor="#fff" />
          <stop offset={0.214} stopColor="#E3E3E3" />
          <stop offset={0.233} stopColor="#E3E3E3" />
          <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
          <stop offset={0.455} stopColor="#E3E3E3" />
          <stop offset={0.549} stopColor="#fff" />
          <stop offset={0.56} stopColor="#E3E3E3" />
          <stop offset={1} stopColor="#E3E3E3" />
        </linearGradient>
        <radialGradient
          id="checkedBaggage_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(11 28.122)scale(1.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1F1F1F" />
          <stop offset={0.462} stopColor="#4D4D4D" />
          <stop offset={0.759} stopColor="#4D4D4D" />
          <stop offset={0.829} stopColor="#3B3B3B" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <radialGradient
          id="checkedBaggage_svg__c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(21 28.122)scale(1.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1F1F1F" />
          <stop offset={0.462} stopColor="#4D4D4D" />
          <stop offset={0.759} stopColor="#4D4D4D" />
          <stop offset={0.829} stopColor="#3B3B3B" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <radialGradient
          id="checkedBaggage_svg__g"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(.2157 10.7959 -12.6106 .545 16.004 16.939)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.538} stopColor="#A179FF" />
          <stop offset={1} stopColor="#885EE4" />
        </radialGradient>
        <filter
          id="checkedBaggage_svg__a"
          width={19.645}
          height={4.617}
          x={6.174}
          y={27.063}
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation={1} />
        </filter>
      </defs>
      <path
        fill="#1C1C1C"
        d="M21.542 7.022h-1.748l-.044-.924c0-.322.26-.583.582-.583h.583c.322 0 .583.261.583.583zm-9.246 0h-1.748l-.044-.924c0-.322.261-.583.583-.583h.582c.322 0 .583.261.583.583z"
        opacity={0.8}
      />
      <g filter="url(#checkedBaggage_svg__a)" opacity={0.5}>
        <ellipse cx={15.996} cy={29.372} fill="#000" rx={7.822} ry={0.309} />
      </g>
      <path
        fill="url(#checkedBaggage_svg__b)"
        d="M11 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
      />
      <path
        fill="url(#checkedBaggage_svg__c)"
        d="M21 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
      />
      <path
        fill="url(#checkedBaggage_svg__d)"
        d="M21 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
      />
      <path
        fill="url(#checkedBaggage_svg__e)"
        d="M11 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
      />
      <path
        fill="url(#checkedBaggage_svg__f)"
        d="M17.876 3.569h-3.75v3.342h-1.25V3.57c0-.73.56-1.322 1.25-1.322h3.75c.69 0 1.25.592 1.25 1.322v3.342h-1.25z"
      />
      <path
        fill="url(#checkedBaggage_svg__g)"
        d="M21.372 6.138h-10.75c-1.036 0-1.875.84-1.875 1.875v18.108c0 1.036.84 1.875 1.875 1.875h10.75a1.874 1.874 0 0 0 1.875-1.875V8.013c0-1.035-.84-1.875-1.875-1.875"
      />
      <path
        fill="#fff"
        d="M13.97 9.194a.313.313 0 0 0-.313.313v16.118a.313.313 0 0 0 .625 0V9.507a.313.313 0 0 0-.313-.313Zm-2.03 0a.313.313 0 0 0-.313.313v16.118a.313.313 0 0 0 .625 0V9.507a.313.313 0 0 0-.313-.313Zm4.062 0a.313.313 0 0 0-.312.313v16.118a.313.313 0 0 0 .625 0V9.507a.313.313 0 0 0-.313-.313m2.03 0a.313.313 0 0 0-.312.313v16.118a.313.313 0 0 0 .625 0V9.507a.313.313 0 0 0-.313-.313m2.03 0a.313.313 0 0 0-.313.313v16.118a.313.313 0 0 0 .626 0V9.507a.313.313 0 0 0-.313-.313"
        opacity={0.4}
      />
      <path
        fill="url(#checkedBaggage_svg__h)"
        d="M15.57 13.824s-.311-.02-.489-.181l.164-2.857h.623s.217.002.369-.049.433-.033.433-.033l.18.033h1.46l.705-.033.108.025c.06.188.301.881.301.881l.087 2.39h-.349l-.375.091-2.247-.167s-.14.026-.322.026c-.183 0-.424-.065-.424-.065l.073.027c-.12-.05-.296-.088-.296-.088Z"
      />
      <path
        fill="#272727"
        d="m19.125 3.555-6.253.023c0-.69.559-1.331 1.25-1.331h3.75c.69 0 1.253.617 1.253 1.308"
        opacity={0.4}
      />
    </svg>
  );
};
export default SvgCheckedBaggage;
